const OVERVIEW_NEW_NAVIGATION_SUFFIX = "/overview";
const PRIMARY_OVERVIEW_NAME = "label(Overview)";

const isOverviewMenuItem = (item) =>
    typeof item?.toNewNavigation === "string" &&
    item.toNewNavigation.endsWith(OVERVIEW_NEW_NAVIGATION_SUFFIX);

const pickPreferredOverviewEntry = (items, getName, getPriority = (item) => item.priority) => {
    const preferred = items.find((item) => getName(item) === PRIMARY_OVERVIEW_NAME);
    if (preferred) {
        return preferred;
    }

    return items.reduce((best, item) => {
        if (!best) {
            return item;
        }

        const bestPriority = getPriority(best) ?? Number.MAX_SAFE_INTEGER;
        const itemPriority = getPriority(item) ?? Number.MAX_SAFE_INTEGER;
        return itemPriority < bestPriority ? item : best;
    }, null);
};

const pickOverviewMenuItem = (items) =>
    pickPreferredOverviewEntry(items, (item) => item.name);

export const filterOverviewMenuForNewNavigation = (modules, menuItems) => {
    if (!Array.isArray(menuItems) || menuItems.length === 0) {
        return menuItems;
    }

    if (!Array.isArray(modules) || !modules.includes("new_navigation")) {
        return menuItems;
    }

    const overviewItems = menuItems.filter(isOverviewMenuItem);
    if (overviewItems.length <= 1) {
        return menuItems;
    }

    const keeper = pickOverviewMenuItem(overviewItems);
    const duplicateOverviewItems = new Set(
        overviewItems.filter((item) => item !== keeper),
    );

    return menuItems.filter((item) => !duplicateOverviewItems.has(item));
};

const isHydratedOverviewLink = (toPath) => {
    if (typeof toPath !== "string" || !toPath) {
        return false;
    }

    const pathWithoutQuery = toPath.split("?")[0];
    return pathWithoutQuery.endsWith(OVERVIEW_NEW_NAVIGATION_SUFFIX);
};

const getHydratedOverviewName = (item) => {
    if (
        item.label === "Overview" ||
        item.id === `${PRIMARY_OVERVIEW_NAME}_0` ||
        (item.id || "").startsWith(`${PRIMARY_OVERVIEW_NAME}_`)
    ) {
        return PRIMARY_OVERVIEW_NAME;
    }

    return item.label || item.id || "";
};

const pickHydratedOverviewLink = (items) =>
    pickPreferredOverviewEntry(items, getHydratedOverviewName);

export const dedupeHydratedOverviewStaticLinks = (staticLinks, hasNewNavigation) => {
    if (!hasNewNavigation || !Array.isArray(staticLinks) || staticLinks.length === 0) {
        return staticLinks;
    }

    const overviewLinks = staticLinks.filter((item) => isHydratedOverviewLink(item.to));
    if (overviewLinks.length <= 1) {
        return staticLinks;
    }

    const keeper = pickHydratedOverviewLink(overviewLinks);
    const duplicateOverviewLinks = new Set(
        overviewLinks.filter((item) => item !== keeper),
    );

    return staticLinks.filter((item) => !duplicateOverviewLinks.has(item));
};
